import React, {Component} from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import {injectIntl} from 'react-intl';

const LimitedMultiSelect = (props) => {
    return (
        <Select
            {...props}
            value={props.input.value}
            options={props.options}
            onChange={(value) => {
                if (value.length <= 3 || value.length < props.input.value.length) {
                    props.input.onChange(value);
                }
            }}
            multi={true}
            placeholder={props.placeholder ? props.placeholder : 'Vælg ...'}
            clearable={false}
            onBlur={() => props.input.onBlur(props.input.value)}
        />
    );
};

export default injectIntl(LimitedMultiSelect);




// WEBPACK FOOTER //
// ./web/src/components/articles/LimitedMultiSelect.jsx